import React, { useState, useEffect } from "react";
import { Button, Box, Typography, Grid } from "@mui/material";
import MyPosts from "../Post/MyPosts";
import MyBookings from "../Platform/MyBookings";
import PaymentDetails from "../Platform/PaymentDetails";
import RecentActivity from "../Platform/RecentActivity";
import Header1 from "../Header/Header1";
import axios from "axios";
import Posted from "../Post/Posted";
import Requested from "../Requests/Requested";
import RequestUsersList from "../Requests/RequestUsersList";
import RequestUser from "../RequestUser/RequestUser";
import RecommendedOrganizationsList from "../Organizations/RecommendedOrganizationsList";
import Platform from "../Platform/Platform";
import Footer2 from "../Footer/Footer2";

const API_URL = process.env.REACT_APP_API_URL;

function Recommended({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const [activePage, setActivePage] = useState("post"); // Default active page
  const [searchResults, setSearchResults] = useState([]);
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleSearch = (result) => {
    setSearchResults(result);
  };


  useEffect(() => {
    const checkVerification = async () => {
      if (!userId) return;

      try {
        const response = await axios.post(`${API_URL}/api/check-verification/`, {
          user_id: userId,
        });

        console.log('is verified', response.data.status)

        setIsVerified(response.data.status === 'approved');
      } catch (error) {
        console.error('Verification check failed:', error);
        setIsVerified(false);
      } finally {
        setLoading(false);
      }
    };

    checkVerification();
  }, [userId]);


  useEffect(() => {
    setActivePage(isVerified ? "request" : "post");
  }, [isVerified]);

  const renderContent = () => {
    switch (activePage) {
      case "post":
        return <Posted userId={userId} searchResults={searchResults} onLogout={onLogout} />;
      case "request":
        return <Requested userId={userId} searchResults={searchResults} onLogout={onLogout} />;

      default:
        return <Typography variant="h4" color="#ecf0f1">Welcome</Typography>;
    }
  };

  return (
    <div>


      <Box
        sx={{
          position: 'fixed', // or 'relative' / 'sticky' based on your layout
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1300, // higher than MUI drawers (default is 1200)
        }}
      >
      </Box>


      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box>
          <Platform userId={userId} onLogout={onLogout} />
        </Box>
        <Box>
          <Typography
            variant="h3"
            component="h1"
            align="center"
            fontSize={{ xs: '1.1rem', sm: '2.5rem', md: '3rem' }}
            sx={{
              backgroundImage: 'linear-gradient(45deg, #fff, #fff)',
              mt: 10,
              letterSpacing: 10,
              WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
              color: 'transparent',  // Makes the text itself transparent to show the gradient
            }}
            gutterBottom
          >
            Explore
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },  // Switch flexDirection to column for small screens, row for larger screens
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'black',
              padding: { xs: '0.5rem', sm: '1rem' },  // Smaller padding for small screens, larger padding for larger screens
              width: '100%',
            }}
          >
            <Grid container spacing={2} justifyContent="center" sx={{ flexDirection: { xs: 'column', sm: 'row' }, textAlign: 'center' }}>
              {/* {isVerified ? (

                <Grid item>
                  <Button
                    onClick={() => setActivePage("request")}
                    sx={{
                      color: activePage === "request" ? "#1E90FF" : "#ecf0f1",
                      textTransform: "none",
                      letterSpacing: 3,
                      fontSize: { xs: '0.9rem', sm: '1rem' }, // Responsive font size
                      width: { xs: '100%', sm: 'auto' }, // Full width on small screens, auto width on larger screens
                      "&:hover": {
                        backgroundColor: "#1111",
                      },
                      padding: { xs: '0.5rem', sm: '1rem' }, // Adjust padding for smaller screens
                    }}
                  >
                    Requested Sessions
                  </Button>
                </Grid>
              ) : ( */}
                <Grid item>
                  <Button
                    onClick={() => setActivePage("post")}
                    sx={{
                      color: activePage === "post" ? "#1E90FF" : "#ecf0f1",
                      textTransform: "none",
                      letterSpacing: 3,
                      fontSize: { xs: '0.9rem', sm: '1rem' }, // Responsive font size
                      width: { xs: '100%', sm: 'auto' }, // Full width on small screens, auto width on larger screens
                      "&:hover": {
                        backgroundColor: "#1111",
                      },
                      padding: { xs: '0.5rem', sm: '1rem' }, // Adjust padding for smaller screens
                    }}
                  >
                    Hosted Sessions
                  </Button>
                </Grid>
              {/* )
              } */}



            </Grid>

          </Box>

          <Box
            sx={{
              padding: { xs: "1rem", sm: "2rem" }, // Adjust padding for smaller and larger screens
              backgroundColor: "black",
              color: "white",
              minHeight: "calc(100vh - 64px)", // Keeps the height full minus any fixed header
              display: "flex",
              flexDirection: "column", // Ensure content is stacked vertically on small screens
              justifyContent: "center", // Centers content vertically
              alignItems: "center", // Centers content horizontally
              overflow: "hidden", // Prevents overflow on smaller screens
            }}
          >
            {renderContent()}
          </Box>

        </Box>
      </Box>
      <Footer2 />

    </div>
  );
}

export default Recommended;
